// extracted by mini-css-extract-plugin
export default {"Dimmer":"styles_Dimmer__yl+BR"};